module.exports = {
    language: {
        name: 'En'
    },
    nav: {
        tab1: '首页',
        tab2: '关于我们',
        tab2_1: '集团介绍',
        tab2_2: '新闻资讯',
        tab3: '加入我们',
        tab3_1: '社会招聘',
        tab3_2: '校园招聘',
        tab4: '联系我们',
        zh: '中',
        en: 'En',
        logo: '盛宝金融科技有限公司',
    },
    home: {
        bannerT2: '集大成以利天下',
        bannerT22: '',
        bannerText: '全球领先的金融科技领导者',
        bannerText2: '金融监管科技专家',
        bannerBth: '关于我们',
        context: '关于我们',
        context2: '加入我们',
        context2_1: '社会招聘',
        context2_2: '校园招聘',
        context3: '联系我们',
        context4: '查看详情'
    },
    About: {
        bannerT2: '关于我们',
        h4: '我们致力于引入全球领先的金融科技技术，助力中国金融机构持续创新发展。',
        fintech: {
            title: '关于盛宝金融科技',
            p: [
                '盛宝金融科技有限公司（以下简称“盛宝金科”）于2020年6月落户重庆两江新区，同年11月开始正式运营。2023年下半年，盛宝金科已正式成为吉利控股集团全资子公司。',
                '盛宝金科持续在金融科技行业深耕，坚持守正创新，多次获得相关权威认证和奖项，为企业发展注入澎湃动力。',
                {
                    type: 'list',
                    name: 'milestone',
                    value: [
                        '2023年成功通过高新技术企业认定',
                        '2023年荣登由重庆市经信委公布的 “专精特新“企业名单',
                        '2023年荣获由两江新区管委会颁布的重庆市 “智汇两江·十大科技创新企业”称号',
                        '2023年荣获重庆国金认证“金融科技服务综合能力AAA级评价”',
                        '22022年度信创应用创新奖',
                        '2022年度新锐金融科技企业',
                        '2022信创产业独角兽TOP100',
                        '……'
                    ]
                },
                '盛宝金科立志成为拥有全球领先金融科技技术且100%自主知识产权的金融科技公司，对标国际最先进技术，填补国内金融科技空白，提供全方位的监管科技、资产管理、产业金融、场景金融、绿色金融等解决方案，为国内金融机构迎接开放保驾护航。'
            ]
        },
        geelyGroup: {
            title: '关于吉利控股集团',
            p: [
                '浙江吉利控股集团（以下简称“吉利控股集团”）始建于1986年，1997年进入汽车行业，一直专注实业，专注技术创新和人才培养，不断打基础练内功，坚定不移地推动企业转型升级和可持续发展。现资产总值超5100亿元，员工总数超过14万人，连续十二年进入《财富》世界500强（2023年排名225位），是全球汽车品牌组合价值排名前十中唯一的中国汽车集团。',
                '吉利控股集团在中国上海、杭州、宁波，瑞典哥德堡、英国考文垂、美国加州、德国法兰克福等地建有造型设计和工程研发中心，研发、设计人员超过3万人。在中国、美国、英国、瑞典、比利时、马来西亚建有世界一流的现代化整车和动力总成制造工厂，拥有各类销售网点超过4000家，产品销售及服务网络遍布世界各地。',
                '吉利控股集团是第19届杭州亚运会官方合作伙伴。吉利汽车启动主题为“科技吉利，悦行亚运”的亚运战略，通过绿色科技、智能科技、人文责任等举措，全方位赋能杭州亚运会。',
                '吉利控股集团秉承“让世界充满吉利”的使命和“充分授权、依法合规、考核清晰、公平透明”的经营管理方针，长期坚持ESG可持续发展战略，在应对气候变化、资源保护、出行安全、社会责任以及商业道德等领域进行科学治理，带动产业链上下游企业协同发展，助力区域经济均衡发展，为创造超越期待的出行体验、实现中国汽车强国梦而不懈努力!'
            ]
        },
        lx: '联系我们',
        lx2: '加入我们',
        xq: '查看详情',
        fs: '28px'
    },
    News: {
        bannerT2: "新闻资讯",
        titile3: "最新新闻  /",
        more: "了解更多",
    },
    Careers: {
        bannerT2: '虚位以待',
    },
    Contact: {
        bannerT2: '联系我们',
        h4: '重庆总部',
        tel: '联系电话',
        Email: 'Email'
    },
    footer: {
        logo: '',
        name: '盛宝金融科技',
        No1: 'Copyright © 2020',
        No2: '渝ICP备2020012418号',
        telText: '服务热线',
        tel: '+86 23 62735888',
        aboutUs: '关于我们',
        contactUs: '联系我们',
        joinUs: '加入我们'
    },

    join: {
        filter: '筛选',
        clear: '清除',
        searching: "搜索职位",
        searchBtn: "搜索",
        posiType: "职位类型",
        city: "城市",
        type: "招聘类型",
        empty: "暂无相关职位!",
    }


}


// WEBPACK FOOTER //
// ./src/components/language/zh.js